import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '../../utils/cn';

export const Switch = React.forwardRef<
    React.ElementRef<typeof SwitchPrimitives.Root>,
    React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
        thumbClassName?: string;
    }
>(({ className, thumbClassName, ...props }, ref) => (
    <SwitchPrimitives.Root
        ref={ref}
        data-slot="switch"
        className={cn(
            'peer inline-flex h-6 w-11 shrink-0 items-center rounded-full border border-transparent shadow-sm outline-none transition-all focus-visible:border-ring focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-gray-900 data-[state=unchecked]:bg-gray-500',
            className
        )}
        {...props}
    >
        <SwitchPrimitives.SwitchThumb
            data-slot="switch-thumb"
            className={cn(
                'pointer-events-none block size-5 rounded-full bg-background ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
                thumbClassName
            )}
        />
    </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;
